import { Link } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";

import DoNotMountComponent from "../../DoNotMountComponent/DoNotMountComponent";
import NextGenerationEU from "../../NextGenerationEU/NextGenerationEU";
import { getSlugWithLang } from "../../shared/utils/getSlugWithLang";
import SocialLinksList from "../../SocialsLinks/SocialLinksList";
import { useLayout } from "../LayoutContext";
import { logoWhite_svg } from "./footer-elements";

export const Footer: React.FC = () => {
  const { legalLinks, navbarLinks, settings } = useLayout();
  if (!navbarLinks || !legalLinks || legalLinks.length < 1 || !settings)
    return <DoNotMountComponent sms={"Footer sin legales"} log={legalLinks} />;
  const { t, i18n } = useTranslation("global");

  return (
    <div className="o-footer">
      <div className="c-footer">
        <div className="footer__container">
          <div className="footer__info">
            {logoWhite_svg}
            <div className="footer__text">
              <p>{`${t("Especializados en metodología BIM para dar vida a las ideas de nuestros clientes.")}`}</p>
            </div>
            <SocialLinksList />
          </div>
          <div className="footer__site-map">
            {/*<p className="footer__section-title">{"Pages"}</p>*/}
            <ul className="footer__pages">
              {navbarLinks?.map((item, index) => (
                <li key={index} className={`footer__item`}>
                  <Link
                    activeClassName={"footer__item--active"}
                    className={`footer__item-link`}
                    to={getSlugWithLang(item.slug, i18n.language)}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <ul className="footer__contact">
            <li className={`footer__item footer__item-link`}>{settings?.postalAddress?.address}</li>
            <li className={`footer__item`}>
              <a
                className={`footer__item-link`}
                href={`mailto:${settings?.email}`}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                {settings?.email}
              </a>
            </li>
            <li className={`footer__item`}>
              <a
                className={`footer__item-link`}
                href={`tel:${settings?.phone}`}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                {settings?.phone}
              </a>
            </li>
          </ul>
        </div>
        <NextGenerationEU itemsColor="light" />
        <div className="footer__foot-line">
          <div className="footer__foot-text">
            <div className="footer__copy">{t("Copyright © 2025 Arquidom. Todos los derechos reservados.")}</div>
            <div className="footer__legal">
              {legalLinks.map((legal, index) => {
                return (
                  <a
                    className={"footer__link"}
                    key={index}
                    href={`${legal.slug}`}
                    title={`${legal.name}`}
                    aria-label={`${t("goto")} ${legal.name}`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    {legal.name}
                  </a>
                );
              })}
              <button className={"footer__button-settings"} type="button" data-cc="show-preferencesModal">
                {t("Configuración cookies")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
